// Defines a parser and serializer for [CommonMark](http://commonmark.org/) text.

exports.schema = require("./schema").schema
;var assign;
((assign = require("./from_markdown"), exports.defaultMarkdownParser = assign.defaultMarkdownParser, exports.MarkdownParser = assign.MarkdownParser))
;var assign$1;
((assign$1 = require("./to_markdown"), exports.MarkdownSerializer = assign$1.MarkdownSerializer, exports.defaultMarkdownSerializer = assign$1.defaultMarkdownSerializer, exports.MarkdownSerializerState = assign$1.MarkdownSerializerState))



//////////////////
// WEBPACK FOOTER
// ../~/prosemirror-markdown/dist/index.js
// module id = 835
// module chunks = 0